// Date range picker for the intake dashboard. One flatpickr input in range
// mode; the form submits the hidden from/to fields so the server never has to
// parse flatpickr's "a to b" display string.
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'

// Turbolinks isn't started, so DOMContentLoaded is the only load event we get
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-range-input]').forEach((input) => {
    const form = input.closest('form')
    const from = form.querySelector('[data-range-from]')
    const to = form.querySelector('[data-range-to]')

    flatpickr(input, {
      mode: 'range',
      dateFormat: 'Y-m-d',
      maxDate: 'today',
      defaultDate: [from.value, to.value],
      onChange(dates) {
        if (dates.length !== 2) return
        from.value = flatpickr.formatDate(dates[0], 'Y-m-d')
        to.value = flatpickr.formatDate(dates[1], 'Y-m-d')
      }
    })
  })
})
